// GovCon certifications/set-aside types — static data
export const SET_ASIDE_TYPES: { code: string; label: string }[] = [
  { code: '8(a)', label: '8(a) Business Development' },
  { code: 'SDVOSB', label: 'Service-Disabled Veteran-Owned Small Business' },
  { code: 'WOSB', label: 'Women-Owned Small Business' },
  { code: 'EDWOSB', label: 'Economically Disadvantaged Women-Owned Small Business' },
  { code: 'HUBZone', label: 'HUBZone Certified' },
  { code: 'VOSB', label: 'Veteran-Owned Small Business' },
  { code: 'SDB', label: 'Small Disadvantaged Business' },
  { code: 'SB', label: 'Small Business' },
  { code: 'ISBEE', label: 'Indian Small Business Economic Enterprise' },
  { code: 'ANT', label: 'AbilityOne / JWOD' },
];

// Industry categories — top-level NAICS sectors
export const INDUSTRIES: string[] = [
  'Aerospace & Defense',
  'Agriculture & Forestry',
  'Construction',
  'Cybersecurity',
  'Education & Training',
  'Energy & Utilities',
  'Engineering Services',
  'Environmental Services',
  'Facilities Management',
  'Financial Services',
  'Healthcare & Medical',
  'Information Technology',
  'Intelligence & National Security',
  'Legal Services',
  'Logistics & Transportation',
  'Management Consulting',
  'Manufacturing',
  'Professional Services',
  'Research & Development',
  'Scientific & Technical Services',
  'Security Services',
  'Telecommunications',
  'Waste Management',
];
